/*
 * @Author: liyihui
 * @Date:
 * @description: 请求处理，中运宝接口
 * @Last Modified by:
 * @Last Modified time:
 */
import axios from 'axios';
import router from '@/router';

import { Message, MessageBox, Loading } from 'element-ui';
import { getToken, getUserId, getRefreshToken, getExpiresTime, setRefreshToken, setExpiresTime, removeToken } from '@/utils/auth';
import { whiteList } from '@/utils/dictionary';
import { closeLoading } from '@/utils/tools';

// 创建axios实例
const service = axios.create({
	baseURL: process.env.BASE_API,
	timeout: 120000,
}); // 请求超时时间

// 取消请求
var CancelToken = axios.CancelToken;

// request拦截器
service.interceptors.request.use(
	config => {
		var cancel;
		config.cancelToken = new CancelToken((c) => {
			cancel = c;
		});

		config.headers['tenant_id'] = 'SICHUAN';
		return config;
	}, error => {
		console.log(error);
		Promise.reject(error);
	},
);

// response 拦截器
service.interceptors.response.use(
	response => {
		var res = response.data;
		// code 0成功 1失败 2失败但要页面显示返回信息
		if (res.code === 2) {
			return res;
		} else if (res.success) {
			return res.data;
		} else if (res.code === 2030010 || res.code === 401) { // 【【【询问这两个代码是否依然存在，是在哪边存在】】】
			closeLoading();
			removeToken();
			MessageBox.confirm('登录已失效', '通知', {
				confirmButtonText: '前往登录',
				cancelButtonText: '确定',
			}).then(() => {
				router.push({ name: 'login', query: { redirect: router.history.current.path, } });
			}).catch(() => {
			});
			return Promise.reject(res.msg);
		} else {
			closeLoading();
			Message({
				dangerouslyUseHTMLString: true,
				message: res.msg,
				type: 'error',
				duration: 5 * 1000,
			});
			return Promise.reject(res.msg);
		}
	}, error => {
		if (error.response.status == 401) {
			removeToken();
			MessageBox.confirm('登录已失效', '通知', {
				confirmButtonText: '前往登录',
				cancelButtonText: '确定',
			}).then(() => {
				router.push({ name: 'login' });
			}).catch(() => {
			});
		}
		return Promise.reject(error);
	},
);

// 	//当路由切换页面的时候，遍历全局数组，将上一个页面的所有请求cancel掉
// 	// Vue.prototype.__cancels__.forEach((cancel) => {
// 	// 	cancel();
// 	// });
// 	// Vue.prototype.__cancels__ = [];
// })

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function XAget(url, params) {
	checkToken();
	return new Promise((resolve, reject) => {
		service.get(url, { params: params }).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err);
		});
	});
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function XApost(url, params) {
	checkToken();
	return new Promise((resolve, reject) => {
		service.post(url, params).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err.data);
		});
	});
}
/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function XAput(url, params) {
	checkToken();
	return new Promise((resolve, reject) => {
		service.put(url, params).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err.data);
		});
	});
}
/**
 * del方法，对应del请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function XAdel(url, params) {
	checkToken();
	return new Promise((resolve, reject) => {
		service.delete(url, params).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err.data);
		});
	});
}


// ———————————————————————————————————————————————token过期续约———————————————————————————————————————————————————————
// 调用接口前的检测逻辑：先检查时间是否超期，超期后进行续约，续约可能成功，继续调动函数；续约可能失败，转向登录
function checkToken() {
	// 如果没有时间，不检测有没有过期
	if (!getExpiresTime()) return;
	let checkNum = getExpiresTime() - new Date();
	// 如果接近过期且没有过期
	if (checkNum < 0) {
	// if (checkNum < 1200000 && checkNum > 0) {
		new Promise((resolve, reject) => {
			axios.create({
				baseURL: process.env.BASE_API,
				timeout: 120000,
				headers: { 'userid': getUserId(), 'Authorization': getToken() },
			}).post('mp-auth/token?grant_type=refresh_token', { refresh_token: getRefreshToken() }).then(res => {
				setExpiresTime(res.data.data.expires_in);
				setRefreshToken(res.data.data.refresh_token);
				resolve(res.data);
			}).catch(err => {
				reject(err.data);
			});
		});
	}
};



// WEBPACK FOOTER //
// ./src/utils/requestTeamXA.js